import tipsBoxModel from './tip-Box.vue';
export default{
    install(Vue, pluginOptions = {}){
        const VueItem = Vue.extend(tipsBoxModel);
        var tipsBox = null;
        function $tipsBox() {
            return new Promise((resolve) => {
                if(!tipsBox) {
                    tipsBox = new VueItem();
                    tipsBox.$mount(tipsBox.$el);
                    document.querySelector('body').appendChild(tipsBox.$el);
                }
                resolve();
            })
        };
        $tipsBox.tips = function(res) {
            return new Promise((resolve) => {
                if (!tipsBox || tipsBox == 'tips') {
                    resolve();
                    return;
                }
                tipsBox.tips(res);
                
            });
        };
        $tipsBox.error = function(res) {
            tipsBox.error(res);
        };
        $tipsBox.confirm = function(res) {
            tipsBox.confirm(res);
        };
        $tipsBox.hide = function() {
            document.querySelector('body').removeChild(tipsBox.$el);
            tipsBox = null;
        };

        //初始化
        $tipsBox();
        Vue.tipsBox = Vue.prototype.$tipsBox = $tipsBox;
    }
}


// WEBPACK FOOTER //
// ./src/components/tip-box/tip-box.js